<div class="datepicker-navigation max-[370px]:scale-90 max-[370px]:-mt-1">
	<div class="flex items-center gap-2 justify-start">
		<ui-button
			type="link-dark"
			icon="x_arrow_left"
			class="hidden sm:block"
			[disabled]="previousMonthDisabled() || disabled()"
			(buttonClicked)="goToPreviousMonth()"
			data-cy="datepicker-previous-button"
		></ui-button>
		<ui-button
			type="link-dark"
			icon="x_arrow_right"
			class="hidden sm:block"
			[disabled]="nextMonthDisabled() || disabled()"
			(buttonClicked)="goToNextMonth()"
			data-cy="datepicker-next-button"
		></ui-button>
		<ui-button
			type="link-dark"
			icon="cal_check"
			[disabled]="disabled()"
			(buttonClicked)="todayClick.emit()"
			data-cy="datepicker-today-button"
		></ui-button>

		<div class="flex gap-2">
			<ui-select
				[options]="monthSelectOptions | monthSelect: year() : minDate() : maxDate()"
				[value]="month()"
				[disabled]="disabled()"
				(selected)="onMonthChange($event)"
				class="w-35 max-[370px]:w-25"
			></ui-select>
			<ui-select
				[options]="yearSelectOptions | yearSelect: minDate() : maxDate()"
				[value]="year()"
				[disabled]="disabled()"
				(selected)="onYearChange($event)"
				class="w-21.75"
			></ui-select>
		</div>
	</div>
</div>
